import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import FormEditor from './formEditor';
import { formTypePermissionSelector } from '../common/classes/permissions';
import appHistory from '../../utils/appHistory';
const normalizeFormId = value => value == null || value === '' ? '' : String(value).toUpperCase();
const DirectFormContainer = _ref => {
  let _ref$form = _ref.form,
    _ref$form2 = _ref$form === void 0 ? {
      active: {
        isNew: false
      }
    } : _ref$form,
    _ref$form2$active = _ref$form2.active,
    _ref$form2$active2 = _ref$form2$active === void 0 ? {} : _ref$form2$active,
    _ref$form2$active2$co = _ref$form2$active2.content,
    _ref$form2$active2$co2 = _ref$form2$active2$co === void 0 ? {} : _ref$form2$active2$co,
    title = _ref$form2$active2$co2.title,
    activeId = _ref$form2$active2.id,
    _ref$formActions = _ref.formActions,
    formActions = _ref$formActions === void 0 ? {} : _ref$formActions,
    id = _ref.match.params.id;
  const routeIdNorm = normalizeFormId(id);
  const activeIdNorm = normalizeFormId(activeId);
  const hasStaleForm = Boolean(routeIdNorm && activeIdNorm && routeIdNorm !== activeIdNorm);

  // Another screen (e.g. cabinet form) may still own form.active — e.g. after
  // browser back to /directForms/:id. Clear so we do not render the wrong form.
  useEffect(() => {
    if (hasStaleForm && formActions !== null && formActions !== void 0 && formActions.showCancel) {
      formActions.showCancel();
    }
  }, [hasStaleForm, formActions]);

  // On cold load (refresh), there is no active form in Redux.
  // Direct forms are transient so we can't fetch — redirect to home.
  useEffect(() => {
    if (!activeId) {
      appHistory.replace('/');
    }
  }, [activeId]);

  // Clean up Redux form state when leaving a direct form so the next page
  // (e.g. a regular form editor) starts with a clean slate.
  useEffect(() => () => {
    if (formActions !== null && formActions !== void 0 && formActions.showCancel) {
      formActions.showCancel();
    }
  }, [formActions]);
  if (!activeId || hasStaleForm) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FormEditor, {
    id: id,
    formTitle: title,
    sectionsLabel: "Sections",
    showSave: false,
    hideBackButton: true,
    related: {
      suppressUnsavedChangesNotification: true
    }
  });
};
DirectFormContainer.propTypes = {
  form: PropTypes.shape({
    active: PropTypes.shape({
      content: PropTypes.shape({
        title: PropTypes.string
      }),
      id: PropTypes.string,
      isNew: PropTypes.bool
    }),
    loading: PropTypes.bool.isRequired,
    pendingChanges: PropTypes.bool.isRequired
  }),
  formActions: PropTypes.shape({
    showCancel: PropTypes.func
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    }),
    url: PropTypes.string
  }).isRequired
};
export { DirectFormContainer as TestDirectFormContainer };
export default entityComposition(DirectFormContainer, ['form'], {
  canView: formTypePermissionSelector('view_detail')
}, []);